import { UPDATEADDRESS, REMOVEADDRESS } from '../types';
import { setSession, getSession, removeSession } from '@utils/storage.js';

export default {
  namespaced: true,
  state: {
    addressInfo: getSession('addressInfo')
  },
  mutations: {
    [UPDATEADDRESS] (state, addressInfo) {
      state.addressInfo = Object.assign({}, state.addressInfo, addressInfo);
      setSession('addressInfo', addressInfo);
    },
    [REMOVEADDRESS] (state) {
      state.addressInfo = '';
      removeSession('addressInfo');
    }
  },
  actions: {
    updateAddress ({ commit }, addressInfo) {
      commit(UPDATEADDRESS, addressInfo);
    },
    removeAddress ({ commit }) {
      commit(REMOVEADDRESS);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/address.js